/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_error } from './alert/error.icon';
import { icon_warning } from './alert/warning.icon';
import { icon_error_outline } from './alert/error_outline.icon';
import { icon_add_alert } from './alert/add_alert.icon';
var icons = {
  "error" : icon_error,
"warning" : icon_warning,
"error_outline" : icon_error_outline,
"add_alert" : icon_add_alert,
};
export { icons };
